/* eslint-disable no-mixed-operators */

import React, { useState, useRef, useEffect } from 'react';

import moment from 'moment-timezone';

import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';

import { HorizontallyCenteringContainer } from '../utils';

import { isDev } from '../../../utils/general-utils';


const STAMP_CARD_INFO_LINK = 'https://swensens.com.sg/dine-collect-stamps-for-rewards/';

const STAMP_CARD_CARD_IMAGE = 'stampcard-2025-widget-background.jpg';
const STAMP_CARD_STAMP_IMAGE = 'stampcard-2025-ice-cream-cone.png';
const STAMP_CARD_STAMP_IMAGE_WIDTH = 857;
const STAMP_POS_BASE_Y = 128;
const STAMP_POS_BASE_X = 40;
const STAMP_SPACE_WIDTH = 100;
const STAMP_WIDTH = 70;
const STAMP_HEIGHT = 120;
const STAMP_POS_SHIFT_X = STAMP_SPACE_WIDTH * (1 - STAMP_WIDTH / STAMP_HEIGHT) / 2;
const STAMP_POS_INTERVAL_X = 115;

const PROMO_IMAGE = 'capture-the-moments-2025-promo-button.png';

const CLOSE_BUTTON_VARIANT = null;  // 'white';

export function parseAddenda(memberData) {
    let numStampCards = 1;
    const stampCards = [[]];

    const addenda = (memberData.__addenda__ || []).map(a => a);
    let lastStamp = null;
    
    addenda
        .filter(a => a.key.startsWith('campaign:stamp-card-2025:'))
        .map(a => ({
            cardNo: Number(a.key.split(':')[2]),
            stampNo: Number(a.key.split(':')[3]),
            data: typeof a.data === 'string' ? JSON.parse(a.data) : a.data,
        }))
        .forEach(a => {
            const { cardNo, stampNo, data } = a;
            if (cardNo > numStampCards) {
                numStampCards = cardNo;
                while (stampCards.length < numStampCards) {
                    stampCards.push([]);
                }
            }
            stampCards[cardNo - 1][stampNo - 1] = data;
        });

    let nextExpiry = null;
    if (stampCards[numStampCards - 1].length > 0) {
        lastStamp = stampCards[numStampCards - 1][stampCards[numStampCards - 1].length - 1]
        if (new Date(lastStamp.expiry_ts_iso) < new Date()) {
            // If the last stamp is expired... new card
            numStampCards++
            stampCards.push([])
        } else {
            nextExpiry = new Date(lastStamp.expiry_ts_iso);
        }
    }
    return {
        numStampCards,
        stampCardNumber: stampCards[numStampCards - 1].length,
        stampCards,
        lastStamp,
        nextExpiry
    }
}

function getStampAngle(idx, round = 0, memberData = null) {
    let n = Number(memberData?.CardInfo?.CardNo) || 82947294;
    let angle = 15 * round;
    for (let i = 0; i < idx + 1; i++) {
        angle = (angle + (n % 23) * (5 + 7 * idx + 4 * round)) % 100 - 50;
        n = Math.floor(n / 10);
    }
    return Math.floor(angle);
}

    function range(size, startAt = 0) {
        return [...Array(size).keys()].map(i => i + startAt);
    }

function DisplayWidget({ showPromoModal, memberData }) {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const scaleFactor = containerWidth > 0 ? (containerWidth / STAMP_CARD_STAMP_IMAGE_WIDTH) : 1;

    const stampProgramInfo = parseAddenda(memberData);
    console.log('stampProgramInfo', stampProgramInfo);

    useEffect(() => {
        // Function to update the width
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        };

        updateWidth(); // Update width initially

        // Add event listener for window resize
        window.addEventListener('resize', updateWidth);

        return () => {
            // Cleanup event listener on component unmount
            window.removeEventListener('resize', updateWidth);
        };
    }, []);

    return (
        <>
            <div ref={containerRef} style={{
                width: 'calc(100% + calc(2*var(--bs-modal-padding))',
                margin: 'calc(-1*var(--bs-modal-padding))',
                position: 'relative',
            }}>
                <a href={STAMP_CARD_INFO_LINK} target="_blank" rel="noopener noreferrer">
                    <img
                        src={STAMP_CARD_CARD_IMAGE} alt="Stamp Card"
                        // onClick={showPromoModal}
                        style={{
                            position: 'relative',
                            width: '100%',
                            zIndex: 0,
                        }}
                    />
                </a>

                {
                    range(Math.min(7, stampProgramInfo.stampCardNumber)).map((idx) => (
                        <img
                            src={STAMP_CARD_STAMP_IMAGE} alt={`Stamp Card Stamp #${idx+1}`}
                            key={`stamp-${idx}`}
                            style={{
                                zIndex: 10,
                                width: `${Math.ceil(0.7 * STAMP_WIDTH * scaleFactor)}px`,
                                height: `${Math.ceil(0.7 * STAMP_HEIGHT * scaleFactor)}px`,
                                position: 'absolute',
                                top: `${(STAMP_SPACE_WIDTH * 0.05 + STAMP_POS_BASE_Y) * scaleFactor}px`,
                                left: `${(STAMP_SPACE_WIDTH * 0.05 + STAMP_POS_BASE_X + STAMP_POS_SHIFT_X + STAMP_POS_INTERVAL_X * idx) * scaleFactor}px`,
                                transform: `rotate(${getStampAngle(idx, stampProgramInfo.numStampCards, memberData)}deg)`,
                                transformOrigin: 'middle center',
                            }}
                        />
                    ))
                }
            </div>
            {
                stampProgramInfo.nextExpiry && (
                    <HorizontallyCenteringContainer>
                        <span style={{
                            fontSize: '0.8em',
                            color: 'var(--bs-body-color)',
                            textAlign: 'center',
                        }}>
                            {`Stamp card expires on ${moment(stampProgramInfo.nextExpiry).format('DD MMM YYYY')}`}
                        </span>
                    </HorizontallyCenteringContainer>
                )
            }
        </>
    );
}

export default function StampCardModal({
    showModal, setShowModal,
    token, memberData, updateMemberData
}) {

    return (
        <Modal
            show={showModal}
            fullscreen={true}
        >
            <Modal.Body
                className='promo-modal-body'
            >
                <div style={{
                    position:'absolute', zIndex: '50',
                    top: '1em', left: '0px', 
                    width: 'calc(100% - 1em)',
                    height: '3em',
                    textAlign: 'right',
                }}>
                    <CloseButton
                        variant={CLOSE_BUTTON_VARIANT}
                        onClick={() => setShowModal(false)}
                    />
                </div>

                {/* <div style={{
                    width: 'calc(100% + calc(2*var(--bs-modal-padding))',
                    height: `${CTM_MAIN_HEIGHT}px`,
                    margin: 'calc(-1*var(--bs-modal-padding))',
                    position: 'relative',
                }}>
                    <img
                        src={CTM_MAIN_IMAGE_FILENAME + CACHE_BREAKER_IN_DEV} alt="Stamp Card Main"
                        style={{
                            position: 'relative',
                            width: '100%',
                            // zIndex: frontBackToggle ? 10 : 40,
                            zIndex: 40,
                        }}
                    />
                </div> */}

                {/* <VerticalSeparator height='calc(var(--bs-modal-padding))'/> */}
            </Modal.Body>
        </Modal>
    )
}

StampCardModal.__display_widget__ = DisplayWidget;

StampCardModal.__heading__ = 'Stamp Card';
StampCardModal.__imgSrc__ = PROMO_IMAGE;
StampCardModal.__onlyShowImage__ = true;
// StampCardModal.__display_start_date__ = (memberData) => { /* see CTM2025 for example */ };
StampCardModal.__start_date__ = new Date('2025-04-15T00:00:00+08:00');
StampCardModal.__end_date__ = new Date('2100-12-31');
StampCardModal.__end_time__ = new Date('2100-12-31T23:59:59+08:00');
// StampCardModal.__override_condition__ = (memberData) => { /* see CTM2025 for example */ };
// StampCardModal.__override_condition__ = (memberData) => isDev && ['82089151', '82331745'].includes(memberData?.CardInfo?.CardNo);
// StampCardModal.__additional_condition__ = (memberData) => { /* see CTM2025 for example */ };
StampCardModal.__additional_condition__ = (memberData) => {
    if (!isDev && (new Date() < new Date('2025-04-30T23:59:59+08:00'))) {
            // Hide if CTM is active before end of CTM
        return (memberData.__addenda__ || []).filter(a => a.key.startsWith('campaign:moments-2025:content:')).length === 0;
    } else {
        return true;
    }
}

StampCardModal.__additional_styles__ = {
    // border: '4px solid gold',
    // marginLeft: '-4px',
    // marginRight: '-4px',
    // border: '4px solid var(--swensens-brand-color)',
    // backgroundColor: 'goldenrod',
};
